import React, { useState, useEffect, useCallback } from "react";

import { Table, Space, Button, Popconfirm, Row } from "antd";

import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import { SearchColumn } from "../../../../components/SearchColumn/SearchColumn";

import { ModalAdd } from "./components/ModalAdd";
import { openNotification } from "../../../../components/Notification";
import { grauInstrucaoService } from "../../../../services/resources/grauInstrucaoService";

export const GrauInstrucao = () => {
  const [grauInstrucao, setGrauInstrucao] = useState([]);

  const [openModal, setOpenModal] = useState(false);

  const [codigo, setCodigo] = useState(null);
  const [codigoDelete, setCodigoDelete] = useState(null);
  const [mode, setMode] = useState("");

  const [disabled, setDisabled] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    getGrauInstrucao();
    // eslint-disable-next-line
  }, []);

  async function getGrauInstrucao() {
    try {
      const { data } = await grauInstrucaoService.loadGrausInstrucao();
      transformList(data);
    } catch (error) {
      openNotification(
        "error",
        <strong>
          Ocorreu um erro ao buscar a lista de grau de instrução!
        </strong>,
        error?.response?.data?.detail
      );
    }
  }

  async function handleDelete(codigo) {
    setConfirmLoading(true);
    setDisabled(true);
    try {
      await grauInstrucaoService.delete(codigo);
      openNotification("success", <strong>Grau de instrução excluído!</strong>);
      getGrauInstrucao();
    } catch (reason) {
      openNotification(
        "error",
        <strong>Não foi possível excluir o grau de instrução!</strong>,
        reason?.response?.data?.detail
      );
    } finally {
      setCodigoDelete(null);
      setConfirmLoading(false);
      setDisabled(false);
    }
  }

  const handleOpenModal = useCallback((grauInstrucao) => {
    setOpenModal(true);
    setCodigo(grauInstrucao?.codigo);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
  }, []);

  const transformList = useCallback((list) => {
    list.sort(function (a, b) {
      return a.descricao > b.descricao ? 1 : b.descricao > a.descricao ? -1 : 0;
    });
    setGrauInstrucao(list);
  }, []);

  const renderTable = () => {
    const columns = [
      {
        title: <strong>Descrição</strong>,
        dataIndex: "descricao",
        key: "descricao",
        ...SearchColumn("descricao"),
      },
      {
        title: <strong>ações</strong>,
        key: "action",
        width: 64,
        render: (grauInstrucao) => (
          <Space size="small">
            <Button
              type="primary"
              className="action-button"
              ghost
              title={`Visualizar grau de instrução ${grauInstrucao?.descricao}`}
              onClick={() => {
                handleOpenModal(grauInstrucao);
                setMode("onView");
              }}
            >
              <EyeOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <Button
              type="primary"
              className="action-button"
              title={`Editar grau de instrução ${grauInstrucao?.descricao}`}
              onClick={() => {
                handleOpenModal(grauInstrucao);
                setMode("onEdit");
              }}
            >
              <EditOutlined style={{ fontSize: "1.2rem" }} />
            </Button>
            <div>
              <Popconfirm
                title={
                  <span>
                    excluir grau de instrução{" "}
                    <strong>{grauInstrucao?.descricao}</strong>?"
                  </span>
                }
                visible={grauInstrucao?.codigo === codigoDelete}
                placement="bottomRight"
                okText="confirmar exclusão"
                cancelText="cancelar"
                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                onConfirm={() => handleDelete(grauInstrucao?.codigo)}
                onCancel={() => setCodigoDelete(null)}
                okButtonProps={{ loading: confirmLoading }}
                disabled={disabled}
                cancelButtonProps={{ disabled: disabled }}
              >
                <Button
                  type="danger"
                  className="action-button"
                  title={`Excluir grauInstrucao ${grauInstrucao?.descricao}`}
                  onClick={() => {
                    setCodigoDelete(grauInstrucao?.codigo);
                  }}
                >
                  <DeleteOutlined style={{ fontSize: "1.2rem" }} />
                </Button>
              </Popconfirm>
            </div>
          </Space>
        ),
      },
    ];
    function showTotal(total) {
      return (
        <>
          Total de <strong>{total}</strong> grau de instrução
        </>
      );
    }
    return (
      <Table
        dataSource={grauInstrucao}
        columns={columns}
        size="small"
        rowKey={({ codigo }) => codigo}
        pagination={{
          size: "small",
          total: grauInstrucao?.length,
          showSizeChanger: true,
          showTotal: showTotal,
        }}
      />
    );
  };

  return (
    <>
      <div className="container-section">
        <Row id="header">
          <h2>LISTA DE GRAU DE INSTRUÇÃO</h2>

          <Button
            type="primary"
            onClick={() => {
              handleOpenModal(null);
              setMode("onCreate");
            }}
          >
            novo grau de instrução
          </Button>
        </Row>
        {renderTable()}
      </div>

      {openModal && (
        <ModalAdd
          onClose={handleCloseModal}
          codigo={codigo}
          mode={mode}
          reload={getGrauInstrucao}
        />
      )}
    </>
  );
};
